/** Название хоста (встраивающего микрофронт сервиса) **/
export enum EMicrofrontendHostName {
  /** Старая форма подачи **/
  AddFrom = 'addForm',
  /** Старая форма подачи **/
  NewAddFrom = 'newAddForm',
  /** Мои объявления **/
  MyOffers = 'myOffers',
}
